// import queryString from "query-string";

export const setCategory = ({ categoryID, section }) => state => {
  const category = state.categories.find(
    category => category.id === categoryID,
  ) || {
    id: undefined,
    name: undefined,
  };

  return {
    ...state,
    [section]: {
      ...state[section],
      category,
    },
  };
};
